import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SvgAdd } from '@/components/Common/icon';
import DatasetsCreate from '@/components/Datasets/Create/datasets';
import DatasetsList from '@/components/Datasets/List';
import ContainerHeader from '@/components/Headers/ContainerHeader';

export default () => {
  const { t } = useTranslation();
  const [opened, { close, open }] = useDisclosure(false);
  const [refreshList, setRefreshList] = useState<number>(0);

  return (
    <>
      <ContainerHeader
        title={t('page.data_set_title')}
        description={t('page.data_set_description')}
        rightSection={
          <Button leftSection={<SvgAdd />} onClick={open}>
            {t('dataset.create')}
          </Button>
        }
      />
      <section className="flex flex-col h-full relative">
        <DatasetsList refreshList={refreshList} />
      </section>
      <DatasetsCreate
        opened={opened}
        onClose={close}
        afterSubmit={() => {
          setRefreshList((state) => state + 1);
        }}
      />
    </>
  );
};
